import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as UserAction from "../stores/user/UserDetailsAction";

export const useIsUserLegallyOk = (userId: string): boolean => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (userId) {
            dispatch(UserAction.requestCurrentUser(userId));
        }
    }, [dispatch, userId]);

    const userDetailsFromState = useSelector(state => state.userDetails?.currentlyLoggedUser);

    return userDetailsFromState === undefined ? true : userDetailsFromState?.privacyNoticeAgreed === true;
};
